import React from 'react'
// import { checkTextTranslation, checkTranslation } from '../../utils/useful'
import Modal from '../Modal'
import TextInput from './TextInput'
import { nanoid } from 'nanoid'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import AdvancedColorInput from './AdvancedColorInput'
import Collapsible from 'react-collapsible'
import FixedView from '../FixedView'
import { getBoundingClientRect } from '../../utils/functions'

class EditList extends React.Component {
    state = {
        items: [],
        disabled: {},
        isOpenCollapse: false,
        colorRef: null,
        colorView: true,
        show: true
    }
    componentDidMount = () => {
        let items = this.props.data ?? null
        if (items) {
            this.setState({ items })
        }
        this.setState({ show: false }, () => {
            setTimeout(() => {
                this.setState({ show: true })
            }, 100)
        })
    }

    changeValue = (key, value, extra, id, index, state) => {
        let items = this.state.items
        let keyMain = state === false ? 'backColor' + id : key
        items[index][keyMain] = value
        this.setState({ items })
    }
    // changeInputValue(target) {
    //     let value = (target.validity.valid) ? target.value : null
    //     if (value !== null) {
    //         this.props.changeValue(this.props.header.key, value, this.props.extra)
    //     }
    // }

    addItem = () => {
        let items = this.state.items
        let id = nanoid()
        let item = { id }
        items.push(item)
        this.setState({ items, show: false }, () => {
            setTimeout(() => {
                this.setState({ show: true })
            }, 100)
        })
        if (this.props.changeValue) {
            this.props.changeValue(this.props.header.key, items, this.props.extra)
        }
    }

    removeItem = (id) => {
        let items = this.state.items
        items = items.filter(item => item.id != id)
        this.setState({ items })
    }

    openModal = () => {
        // this.modal.showModal()
        this.setState({ isOpenCollapse: !this.state.isOpenCollapse })
    }

    postData = () => {
        let items = this.state.items
        // console.log('items=========', items)
        if (this.props.changeValue) {
            this.props.changeValue(this.props.header.key, items, this.props.extra)
        }
        this.setState({ isOpenCollapse: !this.state.isOpenColl })
    }

    onDragEnd = (result) => {
        let items = this.state.items
        let [reorderItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderItem);
        this.setState({ items }, () => {
        });
    }

    colorComponent = (ref) => {
        this[ref].showView()
    }



    render() {
        return (

            <div className="w-100 h-100"  >
                {/* <button className='py-2 w-100 ' style={{ background: '#f6f7f9', borderRadius: '8px', border: '1px solid #f0f2f4' }} onClick={this.openModal}>
                    Open Options
                </button> */}
                {/* <Modal ref={el => this.modal = el} maxWidth={250}> */}
                {/* <Collapsible open={this.state.isOpenCollapse} transitionTime={500}> */}
                <div className='p-1 mt-2 d-flex flex-column align-items-center w-100' style={{ background: '#f6f7f9', borderRadius: '8px' }}>
                    {(this.props.independent || this.props.header.information.independent) &&
                        <div className='text-center py-2' style={{ fontSize: '0.9em', fontWeight: 'bold' }}>
                            Edit or Add
                        </div>
                    }
                    <div className='d-flex flex-column mb-1'>
                        {/* {this.state.items && this.state.items?.map((item, index) => {
                                return (
                                    <div className='p-1 m-1 flexc'>
                                        <img width={20} src='/assets/icons/trash-red.svg' onClick={() => this.removeItem(item.id)} />
                                        <div className='modern-input'>
                                            <TextInput data={item?.title} header={{ key: ('textTitle' + item.id), information: { placeholder: 'Text Input' } }} changeValue={(key, value, extra) => { this.changeValue(key, value, extra, item.id, index) }} />
                                        </div>
                                    </div>
                                )
                            })} */}
                        <DragDropContext onDragEnd={(result) => this.onDragEnd(result)}>
                            <Droppable droppableId="droppable">
                                {(provided) => (
                                    <div className="" {...provided.droppableProps} ref={provided.innerRef}>
                                        {this.state.items.map((item, index) => {
                                            let itemId = {}
                                            this.state.items.forEach((item) => {
                                                itemId[item.id] = this.state.colorRef == ('textColor' + item.id) ? true : false
                                            })
                                            return (
                                                <div key={item.id}>
                                                    <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>
                                                    <Draggable key={item.id} draggableId={item.id} index={index}>
                                                        {(provided, snapshot) => {
                                                            if (snapshot.isDragging) {
                                                                if (!provided.draggableProps) {
                                                                    provided.draggableProps = { style: { zIndex: "999" } };
                                                                }
                                                                let bound = getBoundingClientRect(this.setPositionDiv);
                                                                const offset = { x: bound.left, y: bound.top };
                                                                // console.log(bound)
                                                                const x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                                                                const y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                                                                // console.log("y:", y, "x:", x);
                                                                provided.draggableProps.style.left = x;
                                                                provided.draggableProps.style.top = y;
                                                                provided.draggableProps.style.boxShadow = "0px 0px 10px #10101020";
                                                                provided.draggableProps.style.zIndex = "999";
                                                                provided.draggableProps.style.borderRadius = "10px"
                                                            }
                                                            return (
                                                                <div className='p-1 m-1 flexc' ref={provided.innerRef} {...provided.draggableProps} >
                                                                    <img width={20} src='/assets/icons/trash-red.svg' onClick={() => this.removeItem(item.id)} />
                                                                    <div className='modern-input mx-1' style={{ background: item['backColor' + item.id] ?? '', border: '2px solid #fff' }}>
                                                                        <TextInput data={item['textTitle' + item.id]} header={{ key: ('textTitle' + item.id), information: { placeholder: 'Text Input', textColor: item['textColor' + item.id] ?? '#000' } }} changeValue={(key, value, extra) => { this.changeValue(key, value, extra, item.id, index) }} />
                                                                    </div>
                                                                    <div ref={el => this['nodeDiv' + item.id] = el} onClick={() => this.colorComponent('textColor' + item.id)} className='flexcc position-relative' style={{ width: '50px', fontSize: '16px', height: '42px' }}>
                                                                        <div className='h-100 w-100 flexcc' style={{ background: item['backColor' + item.id] ?? '#fff', color: item['textColor' + item.id] ?? '#000', borderRadius:'8px',fontWeight:'bold'}}>A</div>
                                                                        {/* <div className='h-50 w-100' style={{ background: item['backColor' + item.id] ?? '#fff', borderRadius:'0 0 8px 8px' }} ></div> */}
                                                                    </div>
                                                                    {this.state.show &&
                                                                        <AdvancedColorInput showFocus={false} topOffset={-50} xOffset={-50} zIndex={999} ref={el => this['textColor' + item.id] = el} nodeRef={this['nodeDiv' + item.id]} dataText={item['textColor' + item.id]} dataBack={item['backColor' + item.id]} id2={item.id} displayColorPicker={itemId} header={{ key: ('textColor' + item.id), information: { default: 'transparent', showBox: true } }} changeValue={(key, value, extra, state) => { this.changeValue(key, value, extra, item.id, index, state) }} />
                                                                    }
                                                                    <div {...provided.dragHandleProps}>
                                                                        <img className='flexcc px-2' src='/assets/icons/dragicon.svg' />
                                                                    </div>
                                                                </div>
                                                            );
                                                        }}
                                                    </Draggable>
                                                </div>
                                            );
                                        })}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>

                    <button className='py-1 mb-2 w-90' onClick={() => this.addItem()}>
                        Add New
                    </button>
                    {(this.props.independent || this.props.header.information.independent) &&
                        <button className='py-1 w-90' onClick={() => this.postData()}>
                            Done
                        </button>
                    }
                </div>
                {/* </Collapsible> */}
                {/* </Modal> */}

            </div>
        )
    }
}

export default EditList;